export type OpenExternalUrlOptions = {
    /**
     * When true, `about:blank` may be opened without `noopener` so the caller
     * can navigate the returned Window (popup bootstrap pattern).
     */
    allowAboutBlank?: boolean;
};

/**
 * Open a URL in a new tab with reverse-tabnabbing protections.
 * Returns the Window for about:blank bootstraps; otherwise true/false.
 */
export function openExternalUrl(
    url: string,
    options: OpenExternalUrlOptions & { allowAboutBlank: true },
): Window | null;
export function openExternalUrl(
    url: string,
    options?: OpenExternalUrlOptions,
): boolean;
export function openExternalUrl(
    url: string,
    options: OpenExternalUrlOptions = {},
): boolean | Window | null {
    const trimmed = url.trim();
    if (!trimmed) {
        return options.allowAboutBlank ? null : false;
    }

    if (trimmed === 'about:blank') {
        if (!options.allowAboutBlank) {
            return false;
        }
        return window.open('about:blank', '_blank');
    }

    let resolved: URL;
    try {
        resolved = new URL(trimmed, window.location.origin);
    } catch {
        return false;
    }

    if (resolved.protocol !== 'http:' && resolved.protocol !== 'https:') {
        return false;
    }

    window.open(resolved.href, '_blank', 'noopener,noreferrer');
    return true;
}
